import React from 'react';

const ShowRandom = (props) => {
    // console.log(props)

    return (
        <div>
            <p>{props.random}</p>
        </div>
    );
};

export default ShowRandom;